import React from "react";
import classnames from "classnames";

import { JarvisWidget } from "../../widgets";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as TodoActions from "../TodoActions";

import TodoList from "./TodoList";
import TodoForm from "./TodoForm";

class TodoWidget extends React.Component {
  render() {
    return (
      <JarvisWidget editbutton={false} color="blue" id="todo-widget">
        <header>
          <span className="widget-icon">
            <i className="fa fa-check txt-color-white" />
          </span>

          <h2> Available Assignments </h2>

          <div className="widget-toolbar">

          </div>
        </header>
        <div>
          <div className="widget-body no-padding smart-form">
            <div
              className={classnames({
                hidden: !this.props.newTodo
              })}
            >
              <TodoForm />
            </div>

            <TodoList
              type="HighPriority"
              title="High Priority Jobs"
              icon="warning"
              items={this.props.todos.filter(item => item.type === "HighPriority")}
            />

            <TodoList
              type="NormalPriority"
              title="Normal Priority Jobs"
              icon="file-text"
              items={this.props.todos.filter(item => item.type === "NormalPriority")}
            />

          </div>
        </div>
      </JarvisWidget>
    );
  }
}

export default connect(
  store => store.todo,
  dispatch => bindActionCreators(TodoActions, dispatch)
)(TodoWidget);
